import React from 'react'

const SkySportsSvg = () => (
  <svg viewBox="0 0 617 102.3">
    <g transform="translate(-60.7 -59.9)">
      <linearGradient
        id="sky1"
        y2="163"
        gradientUnits="userSpaceOnUse"
        x2="-3420"
        gradientTransform="matrix(-1 0 0 1 -3268.988 0)"
        y1="59"
        x1="-3420"
      >
        <stop stopColor="#091B4A" offset="0" />
        <stop stopColor="#122D68" offset=".036" />
        <stop stopColor="#122D68" offset=".896" />
        <stop stopColor="#091B4A" offset="1" />
      </linearGradient>
      <path
        fill="url(#sky1)"
        d="M71.6 162c-8.1 0-10.9-4.8-10.9-12.7V72.9c0-7.9 2.9-12.7 10.9-12.7h178v102h-178z"
      />
      <linearGradient
        id="sky2"
        y2="59.1"
        gradientUnits="userSpaceOnUse"
        x2="-3730"
        gradientTransform="matrix(-1 0 0 1 -3268.988 0)"
        y1="163"
        x1="-3730"
      >
        <stop stopColor="#552227" offset="0" />
        <stop stopColor="#C41C2B" offset=".074" />
        <stop stopColor="#C41C2B" offset=".911" />
        <stop stopColor="#FE3446" offset="1" />
      </linearGradient>
      <path
        fill="url(#sky2)"
        d="M250 162V60h417c8.1 0 10.9 4.8 10.9 12.7v76.9c0 7.9-2.9 12.7-10.9 12.7H250z"
      />
      <path
        fill="#FFF"
        d="M668 139c6.9 6.9 7.9 13.3 8.1 14.8.7 0 .9-3 .9-7.6V73.6c0-8.4-2.7-11.3-9.9-11.3-2.4 0-4.8 1.3-8 1.3h-580c-3.2 0-5.6-1.3-8-1.3-7.1 0-9.9 2.8-9.9 11.3v72.6c0 4.5.3 7.6.9 7.6.2-1.4.5-8.4 8.1-14.8 61.4-47.2 532-61.7 598 0z"
        opacity=".4"
      />
      <path
        fill="#FFF"
        d="M183 154c1.2.6 3.7 1.4 6.8 1.4 5.3.1 8.2-1.9 10.4-6.7L228.8 85c-1.2-.6-3.8-1.3-5.9-1.4-3.7-.1-8.6.7-11.8 8.2l-9 22.9-18-29.6c-1.2-.4-4-.9-6.1-.9-6.4 0-10 2.4-13.7 6.4l-17.6 19.3 14.2 22.3c2.6 4.1 6.1 6.1 11.7 6.1 3.7 0 6.7-.8 8.1-1.5l-17-26 12-12.3 20 31.3-12 25zm-37.5-24.1c0 4.7-1.8 7.4-11 7.4-1.2 0-2.3-.1-3.3-.2V75.2c0-4.7 1.6-9.7 10.9-9.7 1.2 0 2.3.1 3.4.3v64.6zm-18.9-9.4c0 8.8-5.7 15.2-17.4 16.4-8.4.9-20.6-.2-26.4-.8-.2-.9-.4-2.1-.4-3 0-7.7 4.1-9.4 8-9.4 4 0 10.4.7 15.1.7 5.2 0 6.8-1.8 6.8-3.4 0-2.2-2.1-3.1-6.1-3.9l-11-2.1c-10.1-2-15-9-15-15 0-8.2 5.8-15.1 17.2-16.3 8.6-.9 19.1.1 24.9.8.2 1 .3 1.9.3 3 0 7.6-4 9.3-7.9 9.3-3 0-7.6-.6-12.9-.6-5.4 0-7.6 1.5-7.6 3.3 0 1.9 2.1 2.7 5.5 3.3l10.5 2c10.8 1.7 15.5 7.9 15.5 15.5zM331 123c0-10.6-6.9-15.8-17.9-18.2l-19-5c-3.5-.8-6.4-1.9-6.4-5.4 0-3.8 3-5.3 11.1-5.3 9.5 0 11.8.5 20.4.5 4 0 8.1-1.9 8.1-9.7 0-1-.1-2-.3-3-5.8-.5-16.3-1.1-29.1-1.1-19.4 0-26.8 8.4-26.8 19.1 0 10 6.3 15.6 17.5 18.2l19.3 4.5c4.5 1.1 6.9 3 6.9 5.8 0 3.8-3.4 5.3-11.5 5.3-9.5 0-13.9-.7-22.6-.7-4 0-8.1 1.8-8.1 9.7 0 1 .1 2 .3 3 5.8.6 18.4 1.3 31.2 1.3 19.5.1 27.2-8.2 27.2-19.6zm329 0c0-10.6-6.9-15.8-17.9-18.2l-19.3-4.4c-3.5-.8-6.4-1.9-6.4-5.4 0-3.8 3-5.3 11.1-5.3 9.5 0 11.8.5 20.4.5 4 0 8.1-1.9 8.1-9.7 0-1-.1-2-.3-3-5.8-.5-16.3-1.1-29.1-1.1-19.4 0-26.8 8.4-26.8 19.1 0 10 6.3 15.6 17.5 18.2l19.3 4.5c4.5 1.1 6.9 3 6.9 5.8 0 3.8-3.4 5.3-11.5 5.3-9.5 0-13.9-.7-22.6-.7-4 0-8.1 1.8-8.1 9.7 0 1 .1 2 .3 3 5.8.6 18.4 1.3 31.2 1.3 19.5.1 27.2-8.2 27.2-19.6zm-170-17V89.6h15.3c6.5 0 11.7 1 11.7 7.8 0 5.7-3.9 8.5-11.7 8.5H490zm-.1 12.8h8.1l15.6 18.6c2.9 3.6 5.7 5.5 12.4 5.5 4.5 0 7.5-.6 9.9-1.8l-20.3-23.5c11.4-2.4 17.1-9.8 17.1-20.7 0-13.4-8.2-20-24.7-20l-23.6-.1c-7.7.3-10.2 2.9-10.2 9.9v55.1c1.2.2 2.5.3 3.9.3 9.7 0 12-2.8 12-7.9l-.2-15.4zM354 108V89.7h15.9c7.9 0 11.8 2.9 11.8 8.7 0 6.1-3.9 9.2-11.8 9.2h-16zm-15.8 34.1c1.2.2 2.5.3 3.9.3 9.7 0 12-2.8 12-7.9v-13.3h16.5c18 0 27-7.8 27-22.4 0-14.1-9-21.6-25.9-21.6h-23.3c-7.8 0-10.2 3-10.2 9.9v55zM450 108c0 7.5-1.3 12.7-3.8 15.9-2.4 3.2-6.4 4.7-11.9 4.7-5.5-.1-9.5-1.7-12.1-4.7-2.5-3-3.8-8.3-3.8-15.9 0-7.5 1.4-12.7 3.9-15.8s6.5-4.6 12-4.6 9.3 1.5 11.9 4.6c2.5 3.1 3.8 8.3 3.8 15.8zm-15.7 33.5c10.2 0 18.1-2.4 23.7-7.4 5.5-4.9 8.4-13.6 8.4-26.1-.1-12.3-2.9-20.8-8.7-25.9-5.7-5-13.5-7.5-23.4-7.5-9.8 0-17.6 2.5-23.4 7.5-5.7 5.1-8.6 13.6-8.7 25.9 0 12.5 2.8 21.2 8.4 26.1 5.6 5 13.5 7.4 23.7 7.4zM575 90.1h12.8c4.2 0 8.5-1.9 8.5-10.2 0-1-.1-2.1-.3-3.1h-49.5c-4.2 0-8.5 1.9-8.5 10.2 0 1 .1 2.1.3 3.1h21v51.6c1.2.2 2.5.3 3.9.3 9.7 0 12-2.8 12-7.9v-44z"
      />
    </g>
  </svg>
)

export default SkySportsSvg
